import { PREVIOUS_URL_PATH } from "../../../../../constants/env";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type {
  IRouteWrapperGetVariant,
  IRouteWrapperVariant,
} from "../../../../../types/layout/route-wrapper-variant.interface";

export class ProfileDataRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return true;
  }
  get headerAvailable(): boolean {
    return true;
  }
  get bottomNavigationAvailable(): boolean {
    return false;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {};
  }

  get titleAvailable(): boolean {
    return true;
  }

  getVariantHeaderSettings({ title, defaultBackButtonUrl }: IRouteWrapperGetVariant): IHeaderV2Store {
    return {
      layoutStore: {
        backButton: {
          url: PREVIOUS_URL_PATH,
          defaultBackUrl: defaultBackButtonUrl,
        },
        actions: [],
        showLogoOnMobile: false,
      },
      contentStore: {
        title,
      },
    };
  }
}
